import { createContext, useEffect, useState } from 'react';

import { cookieConfig } from './config';
import { getParsedCookie, revokeCookies } from './utils';

export type CookieContextProps = {
  services: Record<string, boolean>;
  setServices: (consents: Record<string, boolean>) => void;
  showManager: boolean;
  setShowManager: (value: boolean) => void;
  consentGiven: boolean;
  setConsentGiven: (value: boolean) => void;
  locale: string;
};

export const CookieContext = createContext<CookieContextProps | null>(null);

const CookieProvider = ({ locale, children }: { locale: string; children: React.ReactNode }) => {
  const [services, setServices] = useState<Record<string, boolean>>({});
  const [showManager, setShowManager] = useState(false);
  const [consentGiven, setConsentGiven] = useState(true);

  useEffect(() => {
    if (Object.keys(cookieConfig.services).length > 0) {
      const cookie = getParsedCookie();

      const servicesToDisable = Object.keys(cookieConfig.services).filter(
        (service) => !cookie[service] || cookie[service] === 'false'
      );

      if (servicesToDisable.length > 0) {
        servicesToDisable.forEach((service) => {
          revokeCookies(service);
        });
      }

      if (Object.keys(cookie).length === 0) {
        setConsentGiven(false);
        return;
      }

      const missingServices = Object.keys(cookieConfig.services).filter(
        (service) => !Object.keys(cookie).includes(service)
      );

      if (missingServices.length > 0) {
        setConsentGiven(false);
      }

      setServices(cookie);
    }
  }, []);

  return (
    <CookieContext.Provider
      value={{ services, setServices, showManager, setShowManager, consentGiven, setConsentGiven, locale }}
    >
      {children}
    </CookieContext.Provider>
  );
};

export default CookieProvider;
